export const environment = {
  production: true,
  siteKey: '6LfSpK4gAAAAAJOsfCu5i0vk6gY2GM8w6GnCyngu'
};
